import { Mapper } from "../../../../base/utils/mapper";
import { DeviationResponseModel } from "../../../../domain/models/consult/deviation-response.model";
import { DeviationResponseEntity } from "../entities/deviation-response.entity";

export class DeviationImplementationRepositoryMapper extends Mapper<DeviationResponseEntity, DeviationResponseModel> {
    mapFrom(param: DeviationResponseEntity): DeviationResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DeviationResponseModel): DeviationResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}